export default __webpack_public_path__ + "static/media/mobile_step_3_Hk.16183d70.jpg";